import React, { useState, useLayoutEffect, useEffect } from "react";
import { Edit, Users, UserCheck, UserX, Briefcase, Star, Copy, Clock, MapPin, CheckCircle, TrendingUp, Globe, DollarSign, Settings, Check } from "lucide-react";
import "../../../styles/stores/storeProfile/storeProfileNew.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setPage, setStore } from "../../../slice/storeSlice";
import OpeningHours from "./OpeningHours";
import ImageCropper from "../../../components/imageCropper/ImageCropper";
import { refreshUserToken } from "../../../tools/refreshToken";
import { ImageUploadLoader } from "../../../components/uxCollections/Loaders";
import { getStoreUrl, updateStoreImageUrl, updateStoreTargetUrl, storeReceivingAccountUrl } from "../../../api/endpoints";
import { setUser } from "../../../slice/webStoreUserSlice";
import { FaPencilAlt } from "react-icons/fa";
import StoreModeToggle from "./ToggleSupermarketMode";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
import VATCollectionToggle from "./VAT/VatComponent";
import PaymentAccountsSection from "./receiveingPaymentAct/PaymentAccountsSection";
import StoreStickerRow from "./storeSticker/Storestickerrow";

const StoreDashboard = ({ userSocket }) => {
  const [openModalOpenHours, setOpenModalOpenHours] = useState(false);
  const [storeImageUrl, setStoreImageUrl] = useState(null);
  const [storeImageUrlStage, setStoreImageUrlStage] = useState(null);
  const [storeImageBuffer, setStoreImageBuffer] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [kpiTargets, setKpiTargets] = useState({
    targetProfit: 50000,
    targetSales: 120000,
    currentProfit: 32000,
    currentSales: 85000,
  });
  const [isEditingKpi, setIsEditingKpi] = useState(false);
  const [tempTargets, setTempTargets] = useState(kpiTargets);
  const [openImageCropper, setOpenImageCropper] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //
  const [syncingStaffPortal, setSyncingStaffPortal] = useState(false);
  const [offlinePortalSynced, setOfflinePortalSynced] = useState(false);
  const [refreshingStoreData, setRefreshingStoreData] = useState(false);
  const [savingKpi, setSavingKpi] = useState(false);
  const [copied, setCopied] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);
  const { store } = useSelector((state) => state.store);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    fetchStoreData();
    store && setStoreImageUrl(store.storeImage);
    setKpiTargets({
      targetProfit: store.targetProfit || 50000,
      targetSales: store.targetSales || 120000,
      currentProfit: store.currentProfitToday || 0,
      currentSales: store.currentSalesToday || 0,
    });
    //sockets

    const onOfflineQueueSynced = async ({ isStoreSyned, message }) => {
      // if isStoreSyned is true refesh store data
      if (message && isStoreSyned) {
        uiAlert(`${message}. Store data is up to date`);
        setSyncingStaffPortal(false);
        return;
      }

      if (isStoreSyned) {
        try {
          let response = await fetch(getStoreUrl + store._id, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          });

          if (response.ok) {
            const store = await response.json();
            dispatch(setStore(store));
            setOfflinePortalSynced(true);
            uiAlert("Offline data synchronized successfully. We will refreshed your store data.", "success");
            window.location.reload();
          } else {
            uiAlert("Something went wrong with the syncronization, please refresh the page.", "error");
          }
        } catch (error) {
          console.log(error, "error refreshing store after offline sync");
        } finally {
          setSyncingStaffPortal(false);
        }
      } else {
        uiAlert(message || "Something went wrong with the syncronization, please contact your staff to sync manually.", "error");
        setSyncingStaffPortal(false);
      }
    };

    userSocket.on("offlineQueueSynced", onOfflineQueueSynced);

    return () => {
      userSocket.off("offlineQueueSynced", onOfflineQueueSynced);
    };
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(store.storeLink);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000); // Show checkmark for 2 seconds
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const fetchStoreData = async () => {
    setRefreshingStoreData(true);
    try {
      let response = await fetch(getStoreUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        const store = await response.json();
        dispatch(setStore(store));
        console.log(store, "refreshed store data");
      } else {
        uiAlert("Something went wrong will updating store data, please refresh the page.", "error");
      }
    } catch (error) {
      console.log(error, "error refreshing store data");
    } finally {
      setRefreshingStoreData(false);
    }
  };
  /*  useEffect(() => {
    return () => {
      if (offlinePortalSynced) {
        // reload page to reflect changes
        
      }
    };
  }, [offlinePortalSynced]); */

  useEffect(() => {
    const btn = document.getElementById("syncBtn");
    const btnText = document.getElementById("syncBtnText");
    const lastSyncTime = document.getElementById("lastSyncTime");
    if (syncingStaffPortal) {
      // Disable button and show loading state
      btn.classList.add("syncing");
      btn.disabled = true;
      btnText.textContent = "Syncing...";
    } else {
      // Reset button
      btn.classList.remove("syncing");
      btn.disabled = false;
      btnText.textContent = "Sync Now";
    }
  }, [syncingStaffPortal]);

  useLayoutEffect(() => {
    isLoading && updateStoreImageFun();
  }, [storeImageBuffer]);
  useLayoutEffect(() => {
    setTimeout(() => {
      !openImageCropper && setIsLoading(false);
    }, 2000);
  }, [openImageCropper]);

  const updateStoreImageFun = async () => {
    try {
      let imageToUpdate = new FormData();
      imageToUpdate.append("storeImage", storeImageBuffer);
      let response = await fetch(updateStoreImageUrl + store._id, {
        method: "PUT",
        headers: {
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: imageToUpdate,
      });
      if (response.ok) {
        let { imageUrl, store, user } = await response.json();
        console.log(imageUrl, store);
        dispatch(setStore(store));
        dispatch(setUser(user));
        setStoreImageUrl(imageUrl);
        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(updateStoreImageUrl + store._id, updateStoreImageFun, navigate);
      } else {
        uiAlert("An error occured while updating store image", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateStoreImage = async (e) => {
    setIsLoading(true);
    try {
      let imageBuffere = e.target.files[0];
      /*  setStoreImageBufferStage(imageBuffere);
        setStoreImageBuffer(imageBuffere); */
      if (imageBuffere) {
        const reader = new FileReader();
        reader.onload = function (evt) {
          setStoreImageUrlStage(evt.target.result);
          setOpenImageCropper(true);
        };
        reader.readAsDataURL(imageBuffere);
      }
      //updateStoreImageFun();
    } catch (error) {
      console.log(error);
    }
  };

  const handleVerifyStore = () => {
    uiAlert("Stay tuned!, we will contact you about Store verification soon.");
    return;
    setIsVerified(true);
  };

  const handleKpiEdit = () => {
    setIsEditingKpi(true);
    setTempTargets(kpiTargets);
  };

  const handleKpiSave = async () => {
    setSavingKpi(true);
    let editurl = `${updateStoreTargetUrl + store._id}`;
    const payload = {
      targetProfit: tempTargets.targetProfit,
      targetSales: tempTargets.targetSales,
    };

    try {
      let response = await fetch(editurl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        uiAlert("An error occured while updating store KPI targets", "error");
      }

      setKpiTargets(tempTargets);
      let updatedStore = await response.json();
      dispatch(setStore(updatedStore));
      uiAlert("KPI targets updated successfully", "success");
    } catch (error) {
      console.log(error);
    } finally {
      setSavingKpi(false);
      setIsEditingKpi(false);
    }
  };

  const handleKpiCancel = () => {
    setTempTargets(kpiTargets);
    setIsEditingKpi(false);
  };

  const storeData = {
    name: "Kaosi Stores",
    id: "SBI-12934",
    address: "No 19 Chukwu street Abakaliki",
    category: "Drinks & Water",
    currency: "DKK",
    followers: 0,
    offlineCustomers: 28,
    onlineCustomers: 0,
    employees: 5,
    rating: 0,
    url: "https://ihub.com/stores/KaosiStores/6802b1a...",
    hours: {
      Monday: "01:24 - 23:27",
      Tuesday: "01:24 - 23:27",
      Wednesday: "01:24 - 23:27",
      Thursday: "01:24 - 23:27",
      Friday: "01:24 - 23:27",
      Saturday: "01:24 - 23:27",
      Sunday: "01:24 - 23:27",
    },
  };

  const KpiCard = ({ icon: Icon, title, current, target, unit = "", color = "modern-kpi-default" }) => {
    const percentage = target > 0 ? Math.round((current / target) * 100) : 0;
    const isOverTarget = percentage >= 100;

    if (refreshingStoreData) {
      return <SkeletonCard />;
    }

    return (
      <div className={`modern-kpi-card ${color}`}>
        <div className='modern-kpi-header'>
          <div className='modern-kpi-icon'>
            <Icon size={16} />
          </div>
          <div className='modern-kpi-title'>{title}</div>
        </div>
        <div className='modern-kpi-values'>
          <div className='modern-kpi-current'>
            {user.userCountryCurrencySymbol}
            {current.toLocaleString()}
          </div>
          <div className='modern-kpi-target'>
            Target: {user.userCountryCurrencySymbol}
            {target.toLocaleString()}
          </div>
        </div>
        <div className='modern-kpi-progress'>
          <div className='modern-kpi-progress-bar'>
            <div
              className={`modern-kpi-progress-fill ${isOverTarget ? "modern-kpi-over-target" : ""}`}
              style={{ width: `${Math.min(percentage, 100)}%` }}
            ></div>
          </div>
          <div className={`modern-kpi-percentage ${isOverTarget ? "modern-kpi-percentage-over" : ""}`}>{percentage}%</div>
        </div>
      </div>
    );
  };

  const StatCard = ({ icon: Icon, label, value, trend, color = "modern-stat-default" }) => {
    return (
      <>
        <div className={`modern-stat-card ${color}`}>
          <div className='modern-stat-content'>
            <div className='modern-stat-header'>
              <div className='modern-stat-icon'>
                <Icon size={16} />
              </div>
              {trend && (
                <div className='modern-stat-trend'>
                  <TrendingUp size={12} />
                  <span>+12%</span>
                </div>
              )}
            </div>
            <div className='modern-stat-data'>
              <div className='modern-stat-value'>{value}</div>
              <div className='modern-stat-label'>{label}</div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const HoursCard = ({ day, hours, isToday = false }) => (
    <div className={`modern-hours-card ${isToday ? "modern-hours-today" : "modern-hours-normal"}`}>
      <div className='modern-hours-day'>
        <span className='modern-day-text'>{day.slice(0, 3).toUpperCase()}</span>
        {isToday &&
          (isOpenByMinutes(hours.from, hours.to) ? (
            <div className='modern-status-badge'>
              <div className='modern-status-dot'></div>
              <span>Open</span>
            </div>
          ) : (
            <div style={{ border: "1px solid #a1a1a14a" }} className='modern-status-badge '>
              <div style={{ backgroundColor: "gray" }} className='modern-status-dot'></div>
              <span
                style={{
                  color: "gray",
                }}
              >
                Closed
              </span>
            </div>
          ))}
      </div>
      <div className='modern-hours-time'>{`${hours.from} - ${hours.to}`}</div>
    </div>
  );
  function isOpenByMinutes(openTime, closeTime) {
    console.log(`Open time: ${openTime}, Close time: ${closeTime}`);

    const now = new Date();
    const minutesNow = now.getHours() * 60 + now.getMinutes();

    const [oH, oM] = openTime.split(":").map(Number);
    const [cH, cM] = closeTime.split(":").map(Number);

    const openMinutes = oH * 60 + oM;
    const closeMinutes = cH * 60 + cM;

    console.log(oH, oM, cH, cM, closeMinutes, openMinutes, minutesNow);

    if (closeMinutes > openMinutes) {
      return minutesNow >= openMinutes && minutesNow <= closeMinutes;
    } else {
      // crosses midnight
      return minutesNow >= openMinutes || minutesNow <= closeMinutes;
    }
  }

  const currentDayIndex = new Date().getDay(); // 0 (Sun) to 6 (Sat)

  const handleStayPortalSync = () => {
    setSyncingStaffPortal(true);

    userSocket.emit("staffPortalSync", { roomID: user._id, storeId: store._id });
  };

  //create account
  const handleAddReceivingAccount = async (payload) => {
    try {
      console.log(payload, "payload from handleAddReceivingAccount");
      let response = await fetch(`${storeReceivingAccountUrl + store._id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json(); // Return the newly added account data
      if (!response.ok) {
        throw new Error(data?.message || "Failed to add receiving account");
      }

      dispatch(setStore(data.store)); // Update the store state with the new data

      return data; // Return the newly added account data
    } catch (error) {
      console.log(error, "error adding receiving account");
      uiAlert(error?.message || "An error occured while adding receiving account", "error");
      throw error;
    }
  };

  // update account
  const handleEditReceivingAccount = async (accID, payload) => {
    try {
      console.log(accID, payload, "payload from Edit handleEditReceivingAccount");
      let response = await fetch(`${storeReceivingAccountUrl + store._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      const updatedStore = await response.json(); // Return the newly added account data
      if (!response.ok) {
        throw new Error(updatedStore?.message || "Failed to add receiving account");
      }

      console.log(updatedStore, "updated store");
      dispatch(setStore(updatedStore.store)); // Update the store state with the new data

      return updatedStore; // Return the newly added account data
    } catch (error) {
      console.log(error, "error adding receiving account");
      uiAlert(error?.message || "An error occured while adding receiving account", "error");
      throw error;
    }
  };

  // delete account
  const handleDeleteReceivingAccount = async (accID) => {
    try {
      let response = await fetch(`${storeReceivingAccountUrl + store._id}/${accID}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message || "Failed to delete receiving account");
      }

      dispatch(setStore(data.store)); // Update the store state with the new data

      return data;
    } catch (error) {
      console.log(error, "error deleting receiving account");
      uiAlert(error?.message || "An error occured while deleting receiving account", "error");
      throw error;
    }
  };

  return (
    <>
      <div className='modern-dashboard'>
        <div className='modern-container'>
          {/* Header */}
          <div className='modern-header'>
            <div className='modern-header-content'>
              <div className='modern-store-section'>
                <div className='modern-store-avatar'>
                  <img style={{ border: "1px solid #E5E5E5", width: "100%", borderRadius: "10px" }} src={storeImageUrl} />
                  {!isLoading && (
                    <label>
                      <div className='editPen34'>
                        <FaPencilAlt />
                      </div>
                      <input className='inputSelectImage' type='file' onChange={(e) => updateStoreImage(e)} accept='image/*' />
                    </label>
                  )}
                  {isLoading && (
                    <div id='ImageLoading'>
                      {" "}
                      <ImageUploadLoader />{" "}
                    </div>
                  )}
                </div>
                <div className='modern-store-info'>
                  <div className='modern-store-title'>
                    <h1 className='modern-store-name'>
                      {store.storeName} {store.storeName?.toLowerCase().includes("store") ? "" : "store"}
                    </h1>
                    {/*  <button className='modern-edit-btn'>
                          <Edit size={16} />
                        </button> */}
                  </div>
                  <div className='modern-store-meta'>
                    <div className='modern-meta-item'>
                      <MapPin size={14} />
                      <span>{store.storeAddress}</span>
                    </div>
                    <div className='modern-meta-item'>
                      <span>Store ID: {storeData.id}</span>
                    </div>
                  </div>
                  <div className='modern-verification'>
                    {isVerified ? (
                      <div className='modern-badge modern-badge-verified'>
                        <CheckCircle size={14} />
                        <span>Store is verified</span>
                      </div>
                    ) : (
                      <div className='modern-badge modern-badge-unverified'>Store is not verified</div>
                    )}
                    {!isVerified && (
                      <button className='modern-verify-btn' onClick={handleVerifyStore}>
                        Verify Store
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className='modern-url-section'>
                <div className='modern-url-container'>
                  <Globe size={14} color='#64748b' />
                  <span className='modern-url-text'>{store.storeLink}</span>
                  <button onClick={handleCopy} className='modern-copy-btn'>
                    {copied ? <Check size={14} color='#22c55e' /> : <Copy size={14} color='#64748b' />}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className='modern-main'>
            {/* Stats */}
            <div className='modern-stats-section'>
              <StatCard icon={Users} label='Followers' value={store?.numberOfFollowers} color='modern-stat-blue' />
              <StatCard icon={UserCheck} label='Offline customers' value={store?.offlineCustomers?.length || 0} color='modern-stat-green' trend={true} />
              <StatCard icon={UserX} label='Online customers' value={store.onlineCustomers?.length} color='modern-stat-orange' />
              <StatCard
                icon={Briefcase}
                label='Employees'
                value={user.employees?.length > 0 ? user.employees?.filter((employee) => store._id === employee.storeAssignedID)?.length : 0}
                color='modern-stat-purple'
              />
              <StatCard icon={Star} label='Rating' value={`${store.averageRating}/5`} color='modern-stat-yellow' />
            </div>
            {/* KPI Targets Section */}
            <div className='modern-kpi-section'>
              <div className='modern-kpi-header-section'>
                <div className='modern-kpi-title-section'>
                  <div className='modern-kpi-title-icon'>
                    <TrendingUp size={16} />
                  </div>
                  Store KPI Targets
                </div>
                <div className='modern-kpi-controls'>
                  {!isEditingKpi ? (
                    <button className='modern-kpi-edit-btn' onClick={handleKpiEdit}>
                      <Settings size={14} />
                      Edit Targets
                    </button>
                  ) : (
                    <>
                      {savingKpi ? (
                        <button className='modern-kpi-save-btn' disabled>
                          Saving...
                        </button>
                      ) : (
                        <button className='modern-kpi-save-btn' onClick={handleKpiSave}>
                          Save
                        </button>
                      )}
                      <button className='modern-kpi-cancel-btn' onClick={handleKpiCancel}>
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              </div>

              {!isEditingKpi ? (
                <div className='modern-kpi-grid'>
                  <KpiCard
                    icon={DollarSign}
                    title='Store Profit'
                    current={kpiTargets.currentProfit}
                    target={kpiTargets.targetProfit}
                    unit='$'
                    color='modern-kpi-profit'
                  />
                  <KpiCard
                    icon={TrendingUp}
                    title='Store Sales'
                    current={kpiTargets.currentSales}
                    target={kpiTargets.targetSales}
                    unit='$'
                    color='modern-kpi-sales'
                  />
                </div>
              ) : (
                <div className='modern-kpi-edit-form'>
                  <div className='modern-kpi-form-group'>
                    <label className='modern-kpi-form-label'>Target Profit ({user.userCountryCurrencySymbol})</label>
                    <input
                      type='number'
                      className='modern-kpi-form-input'
                      value={tempTargets.targetProfit}
                      onChange={(e) => setTempTargets({ ...tempTargets, targetProfit: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div className='modern-kpi-form-group'>
                    <label className='modern-kpi-form-label'>Target Sales ({user.userCountryCurrencySymbol})</label>
                    <input
                      type='number'
                      className='modern-kpi-form-input'
                      value={tempTargets.targetSales}
                      onChange={(e) => setTempTargets({ ...tempTargets, targetSales: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  {/*  <div className='modern-kpi-form-group'>
                    <label className='modern-kpi-form-label'>Current Profit ({user.userCountryCurrencySymbol})</label>
                    <input
                      type='number'
                      className='modern-kpi-form-input'
                      value={tempTargets.currentProfit}
                      onChange={(e) => setTempTargets({ ...tempTargets, currentProfit: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div className='modern-kpi-form-group'>
                    <label className='modern-kpi-form-label'>Current Sales ({user.userCountryCurrencySymbol})</label>
                    <input
                      type='number'
                      className='modern-kpi-form-input'
                      value={tempTargets.currentSales}
                      onChange={(e) => setTempTargets({ ...tempTargets, currentSales: parseInt(e.target.value) || 0 })}
                    />
                  </div> */}
                </div>
              )}
            </div>
            {/* receiving payment */}
            <PaymentAccountsSection
              accounts={store.storeReceivingAccounts} // ReceivingAccount docs from your API
              onAddAccount={async (payload) => {
                await handleAddReceivingAccount(payload);
              }} // (payload) => POST
              onUpdateAccount={async (updatedAccountID, payload) => {
                console.log("Update account clicked", updatedAccountID, payload);
                await handleEditReceivingAccount(updatedAccountID, payload);
              }} // (id, payload) => PATCH
              onDeleteAccount={async (id) => {
                await handleDeleteReceivingAccount(id);
              }} // (id) => DELETE
            />
            {/* !-- Staff Portal Sync Card --> */}
            <div class='section'>
              <div class='sync-card'>
                <div class='sync-info'>
                  <div class='sync-icon'>🔄</div>
                  <div class='sync-details'>
                    <h3>Staff Portal Synchronization</h3>
                    <div class='sync-time'>
                      <span class='status'>
                        <span class='status-dot'></span>
                        Last synced:
                      </span>
                      <span id='lastSyncTime'>{store.lastSynced ? formatRelativeFromUTC(store.lastSynced) : "Never synced"}</span>
                    </div>
                  </div>
                </div>
                <button class='sync-btn' id='syncBtn' onClick={handleStayPortalSync}>
                  <span class='spinner'>⟳ </span>
                  <span id='syncBtnText'>Sync Now</span>
                </button>
              </div>
            </div>
            {/* store VAT edit */}
            <VATCollectionToggle
              isEnabled={store.isVATenabled || false}
              defaultVATRate={store.vatPercentage.$numberDecimal || 7}
              storeID={store._id}
              currency={user.userCountryCurrencySymbol}
            />
            {/* store Sticker */}
            <StoreStickerRow
              storeName={store.storeName}
              address={store.storeAddress}
              category={store.category}
              phoneNumber={store.phoneNumber || user.phoneNumber}
              storeUrl={store.storeLink}
            />
            {/* toggle supermarket mode */}
            <StoreModeToggle />
            {/* Business Hours with Store Details */}
            <div className='modern-hours-section'>
              <div className='modern-hours-container'>
                <div className='modern-hours-content'>
                  <div className='modern-hours-header'>
                    <div className='modern-hours-title'>
                      <div className='modern-hours-icon'>
                        <Clock size={16} />
                      </div>
                      Business Hours
                    </div>
                    {store.openingHoursUpdated ? (
                      <button onClick={() => setOpenModalOpenHours(true)} className='modern-update-btn'>
                        Update opening hours
                      </button>
                    ) : (
                      <button onClick={() => setOpenModalOpenHours(true)} className='modern-update-btn'>
                        Set opening hours
                      </button>
                    )}
                  </div>

                  {store.openingHoursUpdated && (
                    <div className='modern-hours-grid'>
                      {Object.entries(store.openingHours).map(([day, hours], i) => {
                        console.log(day, hours, i, currentDayIndex);
                        return <HoursCard key={day} day={day} hours={hours} isToday={currentDayIndex - 1 === i} />;
                      })}
                    </div>
                  )}
                </div>

                {/* Store Details */}
                <div className='modern-details-section'>
                  <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#0f172a", marginBottom: "16px" }}>Store Details</h3>
                  <div className='modern-details-grid'>
                    <div className='modern-form-group'>
                      <label className='modern-form-label'>Category</label>
                      <select className='modern-form-select'>
                        <option>{store.category}</option>
                        {/*   <option>Food & Beverages</option>
                        <option>Electronics</option>
                        <option>Clothing</option> */}
                      </select>
                    </div>
                    <div className='modern-form-group'>
                      <label className='modern-form-label'>Currency</label>
                      <input type='text' value={user.userCountryCurrencyCode} className='modern-form-input' readOnly />
                      <p className='modern-form-help'>Your currency was picked by default according to your geolocation.</p>
                    </div>
                  </div>

                  <div className='modern-danger-section'>
                    <h4 className='modern-danger-title'>Danger Zone</h4>
                    <p className='modern-danger-text'>
                      You will lose access to your store if you close it. However for security reasons, we will retain your store data for 100 days.
                    </p>
                    <button className='modern-danger-btn'>Close Store</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openModalOpenHours && <OpeningHours store={store} closeModal={setOpenModalOpenHours} />}
      {openImageCropper && (
        <ImageCropper
          readImageUrl={storeImageUrlStage}
          setCroppedImageUrl={setStoreImageUrlStage}
          setCroppedImageBolb={setStoreImageBuffer}
          closeModal={setOpenImageCropper}
        />
      )}
    </>
  );
};

export default StoreDashboard;

/**
 * Format a UTC instant as:
 *  - "Today 2:30pm"
 *  - "Yesterday 3:00pm"
 *  - or "Sep 14, 2025 7:05pm"
 *
 * Uses the user's browser timezone (Intl.DateTimeFormat().resolvedOptions().timeZone)
 * for both comparisons and output.
 *
 * @param {Date|string|number} utcInput - A UTC instant (Date | ISO string | epoch ms)
 * @param {string} [locale] - Optional BCP-47 locale (defaults to browser locale)
 */
export function formatRelativeFromUTC(utcInput, locale = undefined) {
  console.log("formatRelativeFromUTC called with:", utcInput, locale);

  const d = new Date(utcInput);
  if (Number.isNaN(d.getTime())) throw new Error("Invalid date");

  // User's browser timezone (e.g., "Europe/Copenhagen")
  const tz = Intl.DateTimeFormat(locale).resolvedOptions().timeZone;

  // Build a Y-M-D key for any Date in a specific TZ (independent of user locale)
  const dateKeyTZ = (date) => {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);

    const get = (t) => parts.find((p) => p.type === t)?.value;
    return `${get("year")}-${get("month")}-${get("day")}`; // e.g. "2025-10-17"
  };

  // Now and yesterday in the user's TZ
  const now = new Date();
  const todayKey = dateKeyTZ(now);
  const yesterdayKey = dateKeyTZ(new Date(now.getTime() - 24 * 60 * 60 * 1000));
  const inputKey = dateKeyTZ(d);

  const timeStr = new Intl.DateTimeFormat(locale, {
    timeZone: tz,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })
    .format(d)
    .replace(/\s?AM$/i, "am")
    .replace(/\s?PM$/i, "pm");

  if (inputKey === todayKey) return `Today ${timeStr}`;
  if (inputKey === yesterdayKey) return `Yesterday ${timeStr}`;

  const dateStr = new Intl.DateTimeFormat(locale, {
    timeZone: tz,
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(d);

  return `${dateStr} ${timeStr}`;
}

function SkeletonCard() {
  return (
    <div className='card-Skeleton'>
      <div className='card-header-Skeleton'>
        <div className='skeleton skeleton-circle'></div>
        <div className='skeleton skeleton-text'></div>
      </div>
      <div className='skeleton skeleton-value'></div>
      <div className='skeleton skeleton-target'></div>
      <div className='skeleton skeleton-bar'></div>
      <div className='skeleton skeleton-percentage'></div>
    </div>
  );
}
